import { useContext } from 'react';
import cls from 'classnames';
import { capitalize } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { RadioContext } from './RadioContext';
import '../InfoCheckbox/index.scss';

export const Radio = ({
    className,
    label,
    tooltip,
    value,
    formGroupClassName = '',
    color = 'primary',
}) => {
    const {
        name, disabled, selected, onChange,
        required = false,
    } = useContext(RadioContext);

    const isSelected = selected === value;

    return (
        <div
            className={cls('form-group', formGroupClassName)}
        >
            <label
                disabled={disabled}
                className={cls(
                    'info-checkbox mb-0 cursor-pointer',
                    className,
                    isSelected && 'checked',
                    `color${capitalize(color)}`,
                    disabled && 'disabled',
                )}
            >
                <div>
                    <input
                        name={name}
                        checked={isSelected}
                        type="radio"
                        onChange={onChange}
                        disabled={disabled}
                        value={value}
                        required={required}
                    />

                    {isSelected ? <FontAwesomeIcon icon={faCircleDot} /> : <FontAwesomeIcon icon={faCircle} />}

                    {label}
                </div>

                {Boolean(tooltip) && (
                    <div>
                        {tooltip}
                    </div>
                )}
            </label>
        </div>
    );
};

export * from './RadioGroup';